/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Turn_Your_Trip_Into_A_Printed_MagazineInputs */

const en_turn_your_trip_into_a_printed_magazine = /** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn your trip into a printed magazine`)
};

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const es_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const fr_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const de_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const ja_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const zh_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const ar_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const id_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const it_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const ru_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const pt_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/** @type {(inputs: Turn_Your_Trip_Into_A_Printed_MagazineInputs) => LocalizedString} */
const ko_turn_your_trip_into_a_printed_magazine = en_turn_your_trip_into_a_printed_magazine;

/**
* | output |
* | --- |
* | "Turn your trip into a printed magazine" |
*
* @param {Turn_Your_Trip_Into_A_Printed_MagazineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const turn_your_trip_into_a_printed_magazine = /** @type {((inputs?: Turn_Your_Trip_Into_A_Printed_MagazineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Turn_Your_Trip_Into_A_Printed_MagazineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "es") return es_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "fr") return fr_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "de") return de_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "ja") return ja_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "zh") return zh_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "ar") return ar_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "id") return id_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "it") return it_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "ru") return ru_turn_your_trip_into_a_printed_magazine(inputs)
	if (locale === "pt") return pt_turn_your_trip_into_a_printed_magazine(inputs)
	return ko_turn_your_trip_into_a_printed_magazine(inputs)
});